import { TranslocoService } from '@jsverse/transloco';

import { kk } from './i18n/kk';
import { ru } from './i18n/ru';
import { en } from './i18n/en';

export * from './components/user-search/user-search.component';
export * from './components/user-select/user-select.component';
export * from './components/call-audio/call-audio.component';
export * from './components/product/info-select/product-info-select.component';
export * from './components/product/info-select/product-info-select.constants';
export * from './components/product/info-select/product-price-label.pipe';
export * from './components/client/search/client-search.component';
export * from './components/client/edit/client-edit.component';
export * from './components/client/edit/client-edit-modal/client-edit.modal';
export * from './components/client/edit/client-edit-modal/client-edit.modal';
export * from './components/client/edit/client-property-edit-modal/client-property-edit.modal';
export * from './components/client/checker/client-checker.component';
export * from './components/client/indicator/client-indicator.component';
export * from './components/product/list/product-list.component';
export * from './components/order/receipt/order-receipt.component';
export * from './components/checkbox/checkbox.component';
export * from './components/loader/hx-loader.component';
export * from './components/rating/rating.component';
export * from './components/manual-address/manual-address.component';
export * from './components/modal/confirm/confirm-modal.component';
export * from './components/event/modal/sms-info-modal.component';
export * from './components/file-list/file-list.component';
export * from './components/file-upload/file-upload.component';
export * from './components/datepicker/datepicker';
export * from './components/datepicker/common';
export * from './components/datepicker/daterangepicker/daterangepicker.component';
export * from './components/datepicker/date-select/date-select.component';
export * from './components/datepicker/date-range-select/date-range-select.component';
export * from './directives/payment-icon.directive';
export * from './components/gis/gis-address.component';
export * from './components/enum-select/enum-select.component';
export * from './components/product/category-select/product-category-select.component';
export * from './components/store-select/store-select.component';
export * from './components/brand-select/brand-select.component';
export * from './components/company-info/company-info.component';
export * from './components/city-select/city-select.component';
export * from './components/bank-select/bank-select.component';
export * from './components/bank-account-select/bank-account-select.component';
export * from './components/invoice-select/invoice-select.component';
export * from './components/dictionary-select/dictionary-select.component';
export * from './components/country-select/country-select.component';
export * from './components/language-select/language-select.component';
export * from './components/modal/modal-actor/modal-actor.component';
export * from './components/comment/list/comment-list.component';
export * from './components/comment/modal/comment-add.modal';
export * from './components/client-list/client-list.component';
export * from './components/rejection-list/rejection-list.component';
export * from './components/faq-list/faq-list.component';

export function addI18n(tr: TranslocoService) {
  tr.setTranslation(kk, 'kk', {merge: true});
  tr.setTranslation(ru, 'ru', {merge: true});
  tr.setTranslation(en, 'en', {merge: true});
}
